import { Navigate, Outlet, useLocation } from "react-router-dom";
// @ts-expect-error pure js
import Unauthorized from "../../pages/Unauthorized";
// @ts-expect-error pure js
import useAuth from "../../hooks/use-auth.js";

// Tant que l'onboarding n'est pas terminé (home /tbd ou /subscription), on
// bloque l'accès au reste de l'app : sinon un simple rechargement de page
// permet d'atterrir sur le dashboard sans jamais compléter le profil ni
// passer par la souscription. /bailleur/stripe/return reste accessible car
// le 3D Secure de la souscription y redirige (dans une iframe).
const ONBOARDING_ALLOWED_PATHS: Record<string, string[]> = {
  "/tbd": ["/tbd"],
  "/subscription": ["/subscription", "/bailleur/stripe/return"],
};

interface RequireAuthProps {
  adminPage?: boolean;
}

export default function RequireAuth({ adminPage }: RequireAuthProps) {
  const {
    auth: { accessToken, role, home },
    isImpersonated,
  } = useAuth();
  const location = useLocation();
  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const allowedPaths = ONBOARDING_ALLOWED_PATHS[home];
  if (
    allowedPaths &&
    !isImpersonated &&
    !allowedPaths.includes(location.pathname)
  ) {
    return <Navigate to={home} replace />;
  }
  if (!adminPage || (adminPage && role?.length > 0)) {
    return <Outlet />;
  }
  return <Unauthorized />;
}
